export default "__VITE_ASSET__feacfec4__"